import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/syne/latin-800.css';
import App from './App';
import './styles/global.css';
import './ios-web/styles.css';
import './styles/working-paper.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><App /></React.StrictMode>,
);
